module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-1-e41959b94044288a5ed3d7364c0ba471.png";